import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { 
    Alert,
    Form,
    Label,
    Col, 
    Row,
    Input,
    FormGroup,
    ButtonGroup,
    Button,
    Card,
    CardBody,
    CardHeader,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';

import { 
    getDetailRole,
    saveRole,
    deleteRole,
    clearFormRole
} from '../../actions/roleAction';

import Loading from 'react-loading-animation';

import { errorMessage, hasError, textValue, textChange } from '../../utils/form';
import { ButtonLoading } from '../../components/Button';

class RoleForm extends Component{
    constructor(props){
        super(props);
        this.state={
            _edit:this.props.edit,
            _readOnly:this.props.readOnly,
            _hasId:this.props.match.params.id?true:false,
            _form:{
                binding:false,
                id:this.props.match.params.id,
                name:'',
                display_name:'',
                description:'',
                created_at:'',
                updated_at:''
            },
            _redirect:'/roles',
            _hasDeleted:false,
            _deleteProcess:false,
            _errors:[],
            _success:[],
            _formSubmit:false,
            _modalDelete:false
        }
        this.onSubmit=this.onSubmit.bind(this);
        this.onDelete=this.onDelete.bind(this);
        this.toggle=this.toggle.bind(this);
        this.handleChange=this.handleChange.bind(this);
    }

    componentDidMount()
    {
        if(this.state._hasId)
            this.props.find(this.state._form.id);
        else
            this.props.new();
    }

    componentWillReceiveProps(nextProps)
    {
        const {detail,isFetch,isSubmit,error} = nextProps.role;
        if((!isFetch&&isFetch!==this.props.role.isFetch)||(!isSubmit&&isSubmit!==this.props.role.isSubmit)){
            // Edit Form
            if(this.state._hasId){
                // Checking if already ok after get detail from api
                if(detail.status_code===200&&error===null){
                    // Binding data when load page and after get detail from api
                    if(!this.state._form.binding){
                        const _form  ={ ...this.state._form };
                        _form.binding=true; 
                        this.setState({_form},()=>{
                            const _newForm  ={ 
                                ...this.state._form,
                                ...detail
                            };
                            this.setState({_form:_newForm});
                        });
                    }
                    else if(this.state._formSubmit){
                        const _form  ={ ...this.state._form };
                        this.setState({_formSubmit:!this.state._formSubmit},()=>{
                            const _errors = this.state._errors.filter(item=>item.key!=='roleForm');
                            const _newForm  ={ ...this.state._form,...detail };
                            const {_success}=this.state;
                            _success.push({key:'roleForm',message:nextProps.role.success});
                            this.setState({_form:_newForm,_success,_errors});
                        });
                    }
                    else if(this.state._deleteProcess&&detail.delete===true){
                        this.setState({_hasDeleted:true,_deleteProcess:!this.state._deleteProcess});
                        if(this.state._modalDelete){
                            this.toggle();
                        }
                    }
                }
                else{
                    const _errors = this.state._errors.filter(item=>item.key!=='roleForm');
                    _errors.push({key:'roleForm',...error});
                    this.setState({_errors,_formSubmit:false,_deleteProcess:false});
                }
            }
            else{
                if(detail.status_code===200&&error===null){
                    if(this.state._formSubmit){
                        const {_success}=this.state;
                        const _errors = this.state._errors.filter(item=>item.key!=='roleForm');
                        _success.push({key:'roleForm',message:nextProps.role.success});
                        this.props.new();
                        this.setState({_formSubmit:!this.state._formSubmit,_success,_errors});
                    }
                }
                else{
                    const _errors = this.state._errors.filter(item=>item.key!=='roleForm');
                    _errors.push({key:'roleForm',...error});
                    this.setState({_errors,_formSubmit:false});
                }
            }
        }
        else if(detail!==this.props.role.detail){
            this.setState({_form:{
                ...this.state._form,
                name:'',
                display_name:'',
                description:'',
                created_at:'',
                updated_at:''
            }})
        }
    }

    onSubmit(e){
        e.preventDefault();
        this.setState({_formSubmit:true},()=>{
            this.props.save(this.state._form);
        })
    }

    renderInfo(key){
        let infoMessage=[];
        const {_errors,_success}=this.state;
        if(this.state._formSubmit)
            infoMessage.push(
                <Alert color='info' key="info"><strong>Heads up!</strong> Submitting...</Alert>
            );
        if(_success.filter(item=>item.key==key).length)
            infoMessage.push(
                <Alert color='success' key="success"isOpen={true}
                toggle={()=>{
                    this.setState({_success: _success.filter(item=>item.key!=key)})
                }}><strong>Well done!</strong> { _success.filter(item=>item.key==key)[0].message }</Alert>
            );
        if(_errors.filter(item=>item.key==key).length)
        {
            const {status_code,message} = _errors.filter(item=>item.key==key)[0];
            switch(status_code)
            {
                case 422:
                    infoMessage.push(
                        <Alert color='danger' 
                        key="error422"   
                        isOpen={true} 
                        toggle={()=>{
                            this.setState({_errors: _errors.filter(item=>item.key!=key)})
                        }}>
                            <strong>Oh Snap!</strong> Please fullfill your form. 
                        </Alert>
                    );
                    break;
                case 404:
                    infoMessage.push(
                        <Alert color='danger' key="error404"  isOpen={true}
                        toggle={()=>{
                            this.setState({_errors: _errors.filter(item=>item.key!=key)})
                        }}><strong>Oh Snap!</strong> Resource not found. </Alert>
                    );
                    break;
                default:
                    infoMessage.push(
                        <Alert color='danger' key={`error${status_code}`} isOpen={true}
                        toggle={()=>{
                            this.setState({_errors: _errors.filter(item=>item.key!=key)})
                        }}><strong>Oh Snap!</strong> We've got something errors </Alert>
                    );
                    break;
            }
        }
        return(
            <div className="row">
                <div className="col-sm-12">
                    {infoMessage}   
                </div>
            </div>
        )
    }

    getErrorFormState(key){
        const filtered=this.state._errors.filter(item=>item.key===key);
        return filtered.length?{...filtered[0]}:null;
    }
    
    toggle(){
        this.setState({_modalDelete:!this.state._modalDelete});
    }

    onDelete(){
        this.props.delete(this.state._form.id);
        this.setState({_deleteProcess:true});
    }

    handleChange(e){
        const _form=textChange(e,this.state._form);
        this.setState({_form});
    }

    renderForm(){
        if(this.props.role.isFetch)
            return <Loading/>
        return(
            <Form onSubmit={this.onSubmit}>
                <Row>
                    <Col xs={12} md={6}>
                        <FormGroup className={hasError('name',this.getErrorFormState('roleForm'))?' has-danger has-feedback':''}>
                            <Label for="formName">Name</Label>
                            <Input
                                type="text"
                                id="formName"
                                name="name"
                                disabled={this.state._edit}
                                value={textValue('name',this.state._form)}
                                onChange={this.handleChange}
                                placeholder="Enter a name of role*"
                            />
                            {errorMessage('name',this.getErrorFormState('roleForm'))}
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6}>
                        <FormGroup className={hasError('display_name',this.getErrorFormState('roleForm'))?' has-danger has-feedback':''}>
                            <Label for="formDisplayName">Display Name</Label>
                            <Input
                                type="text"
                                id="formDisplayName"
                                name="display_name"
                                placeholder="Enter a display name"
                                value={textValue('display_name',this.state._form)}
                                onChange={this.handleChange}
                            />
                            {errorMessage('display_name',this.getErrorFormState('roleForm'))}
                        </FormGroup>
                    </Col>
                </Row>
                <FormGroup className={hasError('description',this.getErrorFormState('roleForm'))?' has-danger has-feedback':''}>
                    <Label for="formDescription">Description</Label>
                    <Input
                        type="text"
                        id="formDescription"
                        name="description"
                        value={textValue('description',this.state._form)}
                        onChange={this.handleChange}
                        placeholder="Description"
                    />
                    {errorMessage('description',this.getErrorFormState('roleForm'))}
                </FormGroup>
                <FormGroup>
                    <Label>Created At</Label>
                    <Input
                        type="text"
                        readOnly
                        value={this.state._form.created_at}
                    />                                    
                </FormGroup>
                <FormGroup>
                    <Label>Updated At</Label>
                    <Input
                        type="text"
                        readOnly
                        value={this.state._form.updated_at}
                    />                                    
                </FormGroup>
                <FormGroup>
                    <ButtonGroup>
                        <ButtonLoading isLoading={this.state._formSubmit}>Submit</ButtonLoading>
                        {
                            this.state._hasId?
                            <Button  color="danger" onClick={this.toggle}>Delete</Button>
                            :
                            ''
                        }
                    </ButtonGroup>
                </FormGroup>
            </Form>
        )
    }
    render(){
        if(this.state._hasDeleted===true)
            return <Redirect to={this.state._redirect}/>
        return(
            <Row>
                <Modal isOpen={this.state._modalDelete} toggle={this.toggle} className="modal-dialog modal-sm">
                    <ModalHeader toggle={this.toggle}>Confirmation</ModalHeader>
                    <ModalBody>
                        Are you sure to delete this?
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.onDelete}>Yes</Button>{' '}
                        <Button color="secondary" onClick={this.toggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Col xs={12} md={{size:8, offset:2}}>
                    <Card>
                        <CardHeader>
                            <i className="fa fa-align-justify"></i> {this.props.title}
                        </CardHeader>
                        <CardBody>
                            { this.renderInfo('roleForm') }
                            { this.renderForm() }
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )
    }
}
const mapStateToProps= (state) => {
	return {
		role:state.role
	}
};
const mapDispatchToProps = (dispatch) => {
	return{
		find:(id) => dispatch(getDetailRole(id)),
		delete:(id) => dispatch(deleteRole(id)),
		save:(payload) => dispatch(saveRole(payload)),
        new:() => dispatch(clearFormRole())
	}
};
export default connect(mapStateToProps,mapDispatchToProps)(RoleForm);